import {
  POST_EMPLOYEE_DETAILS_REQUEST,
  POST_EMPLOYEE_DETAILS_SUCCESS,
  POST_EMPLOYEE_DETAILS_FAIL,
  POST_EMPLOYEE_QUALIFICATIONS_REQUEST,
  POST_EMPLOYEE_QUALIFICATIONS_SUCCESS,
  POST_EMPLOYEE_QUALIFICATIONS_FAIL,
  POST_EMPLOYEE_DEPENDENTS_REQUEST,
  POST_EMPLOYEE_DEPENDENTS_SUCCESS,
  POST_EMPLOYEE_DEPENDENTS_FAIL,
  POST_PREVIOUS_EMPLOYMENT_REQUEST,
  POST_PREVIOUS_EMPLOYMENT_SUCCESS,
  POST_PREVIOUS_EMPLOYMENT_FAIL,
  POST_WORKPLACE_RELATIONSHIPS_REQUEST,
  POST_WORKPLACE_RELATIONSHIPS_SUCCESS,
  POST_WORKPLACE_RELATIONSHIPS_FAIL,
  GET_EMPLOYEE_BY_SERVICENO_REQUEST,
  GET_EMPLOYEE_BY_SERVICENO_SUCCESS,
  GET_EMPLOYEE_BY_SERVICENO_FAIL,
  GET_EMPLOYEE_DETAILS_BY_USER_REQUEST,
  GET_EMPLOYEE_DETAILS_BY_USER_SUCCESS,
  GET_EMPLOYEE_DETAILS_BY_USER_FAIL,
  GET_EMPLOYEE_QUALIFICATIONS_REQUEST,
  GET_EMPLOYEE_QUALIFICATIONS_SUCCESS,
  GET_EMPLOYEE_QUALIFICATIONS_FAIL,
  GET_EMPLOYEE_DEPENDENTS_REQUEST,
  GET_EMPLOYEE_DEPENDENTS_SUCCESS,
  GET_EMPLOYEE_DEPENDENTS_FAIL,
  GET_PREVIOUS_EMPLOYMENT_REQUEST,
  GET_PREVIOUS_EMPLOYMENT_SUCCESS,
  GET_PREVIOUS_EMPLOYMENT_FAIL,
  GET_WORKPLACE_RELATIONSHIP_REQUEST,
  GET_WORKPLACE_RELATIONSHIP_SUCCESS,
  GET_WORKPLACE_RELATIONSHIP_FAIL,
} from "../constants/EmployeeRegisterConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

export const PostEmployeeDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_EMPLOYEE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case POST_EMPLOYEE_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const PostEmployeeQualificationsReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case POST_EMPLOYEE_QUALIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_EMPLOYEE_QUALIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case POST_EMPLOYEE_QUALIFICATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const PostEmployeeDependentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_EMPLOYEE_DEPENDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_EMPLOYEE_DEPENDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case POST_EMPLOYEE_DEPENDENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const PostPreviousEmploymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_PREVIOUS_EMPLOYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_PREVIOUS_EMPLOYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case POST_PREVIOUS_EMPLOYMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const PostWorkplaceRelationshipsReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case POST_WORKPLACE_RELATIONSHIPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_WORKPLACE_RELATIONSHIPS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case POST_WORKPLACE_RELATIONSHIPS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

//get reducers
export const GetAllEmployeesReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_EMPLOYEE_DETAILS_BY_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EMPLOYEE_DETAILS_BY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_EMPLOYEE_DETAILS_BY_USER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const GetEmployeeByServiceNoReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_EMPLOYEE_BY_SERVICENO_REQUEST:
      return {
        ...state, 
        loading: true,
        error: null,
      };
    case GET_EMPLOYEE_BY_SERVICENO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_EMPLOYEE_BY_SERVICENO_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const GetWorkplaceRelationshipsReducer = (
  state = initialState, 
  action,
) => {
  switch (action.type) {
    case GET_WORKPLACE_RELATIONSHIP_REQUEST:
      return {
        ...state,
        loading: true, 
        error: null,
      };
    case GET_WORKPLACE_RELATIONSHIP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_WORKPLACE_RELATIONSHIP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const GetPreviousEmploymentReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_PREVIOUS_EMPLOYMENT_REQUEST:
      return {
        ...state, 
        loading: true,
        error: null,
      };
    case GET_PREVIOUS_EMPLOYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload, 
        error: null,
      };
    case GET_PREVIOUS_EMPLOYMENT_FAIL:
      return {
        ...state, 
        loading: false, 
        error: action.payload
      };
    default:
      return state;
  }
};

export const GetEmployeeDependentsReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_EMPLOYEE_DEPENDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EMPLOYEE_DEPENDENTS_SUCCESS:
      return { 
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_EMPLOYEE_DEPENDENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const GetEmployeeQualificationsReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_EMPLOYEE_QUALIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EMPLOYEE_QUALIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_EMPLOYEE_QUALIFICATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};